import { UpdateHealthCareWorkerTabsInputModelInput } from '@ecdlink/graphql';

export type ClientDashboardRouteState = {
  activeTabIndex?: number;
  isFindClient?: boolean;
};

export const tabKeyMap: Record<
  keyof UpdateHealthCareWorkerTabsInputModelInput,
  | 'dashboardclient'
  | 'dashboardclientb'
  | 'dashboardhighlights'
  | 'dashboardvisits'
  | 'visits'
  | 'progress'
  | 'referrals'
  | 'contact'
> = {
  clickedDashboardClientsTab: 'dashboardclient',
  clickedDashboardClientsTabB: 'dashboardclientb',
  clickedDashboardVisitsTab: 'dashboardvisits',
  clickedDashboardHighlightsTab: 'dashboardhighlights',
  clickedVisitTab: 'visits',
  clickedProgressTab: 'progress',
  clickedReferralsTab: 'referrals',
  clickedContactTab: 'contact',
};

export enum HcwTabNames {
  Clients = 'Clients',
  Visits = 'Visits',
  Highlights = 'Highlights',
}

export const HcwTabIndex = {
  CLIENT: 0,
  VISIT: 1,
  HIGHLIGHTS: 2,
};
